import { Menu, MenuItem } from '@mui/material'
import { useContext, useMemo, useState } from 'react'

import { InspectionEntryStatusChip } from '../../../components/Inspections/InspectionEntryStatusChip'
import { EntryWithRelated } from '../../../models/inspections'
import { ReplicacheContext } from '../../../providers/ReplicacheProvider/ReplicacheProvider'
import { updateInspectionEntryCache } from '../../../replicache/mutateFunction'
import { EntryInfoStatusEnum, InspectionEntryStatusEntry } from '../../../sdk'

export const SelectInspectionEntryStatusChipCached = ({
  entry,
  inspectionId,
  activeStatuses
}: {
  entry: EntryWithRelated
  inspectionId: string
  activeStatuses: InspectionEntryStatusEntry[] | undefined
}) => {
  const { replicacheInstance } = useContext(ReplicacheContext)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const handleChange = async (status: InspectionEntryStatusEntry) => {
    const updatedEntry = {
      ...entry,
      info: {
        ...entry.info!,
        customStatus:
          status.id === EntryInfoStatusEnum.NotInspected
            ? undefined
            : status.id,
        complete:
          status.id === EntryInfoStatusEnum.NotInspected
            ? undefined
            : new Date()
      },
      status
    }
    setAnchorEl(null)
    updateInspectionEntryCache(inspectionId, updatedEntry, replicacheInstance)
  }

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const usedStatuses = useMemo(
    () =>
      !entry.info!.customStatus ||
      activeStatuses?.find((s) => s.id === entry.info!.customStatus)
        ? activeStatuses
        : activeStatuses &&
          entry.status && [
            ...activeStatuses,
            {
              ...entry.status,
              info: {
                ...entry.status.info!,
                title: entry.status.info!.title + ' (Outdated)'
              }
            }
          ],
    [activeStatuses, entry.info, entry.status]
  )

  return (
    <>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}>
        {usedStatuses?.map((status) => (
          <MenuItem key={status.id} onClick={handleChange.bind(null, status)}>
            {status.info?.title}
          </MenuItem>
        ))}
      </Menu>
      <InspectionEntryStatusChip status={entry.status} onClick={handleClick} />
    </>
  )
}
